import { FAILURE, REQUEST, SUCCESS } from 'utils/actionTypeUtil';
import { API_URL } from 'constants/apiUrl';
import axios from 'axios';
import { surveyDataDefault } from 'utils/valueDefault';

const apiUrl = `${API_URL}/survey`;

export const ACTION_TYPES = {
  FETCH_SURVEY_LIST: 'survey/FETCH_SURVEY_LIST',
  FETCH_SURVEY: 'survey/FETCH_SURVEY',
  CREATE_SURVEY: 'survey/CREATE_SURVEY',
  UPDATE_SURVEY: 'survey/UPDATE_SURVEY',
  DELETE_SURVEY: 'survey/DELETE_SURVEY',
  UPDATE_CHOICE: 'survey/UPDATE_CHOICE',
  ADD_CHOICE: 'survey/ADD_CHOICE',
  PREVIEW_SELECT_CHOICE: 'survey/PREVIEW_SELECT_CHOICE',
  REMOVE_CHOICE_SURVEY: 'survey/REMOVE_CHOICE_SURVEY',
  PREVIEW_RESET_CHOICE: 'survey/PREVIEW_RESET_CHOICE',
  RESET: 'survey/RESET',
};

const initial = {
  loading: false,
  errorMessage: null,
  updating: false,
  updateSuccess: false,
  previewAnswer: [],
  entities: [],
  entity: surveyDataDefault, //defaultValue
  pageable: {
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    pageSize: 10,
    pageNumber: 0,
    offset: 0,
    paged: true,
    unpaged: false,
  },
  totalElements: 0,
  last: false,
  totalPages: 0,
  sort: {},
  first: true,
  numberOfElements: 0,
  size: 0,
  number: 0,
  empty: true,
};

// REDUCER
const surveyReducer = (state = initial, action) => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_SURVEY_LIST):
    case REQUEST(ACTION_TYPES.FETCH_SURVEY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_SURVEY):
    case REQUEST(ACTION_TYPES.UPDATE_SURVEY):
    case REQUEST(ACTION_TYPES.DELETE_SURVEY):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_SURVEY_LIST):
    case FAILURE(ACTION_TYPES.FETCH_SURVEY):
    case FAILURE(ACTION_TYPES.CREATE_SURVEY):
    case FAILURE(ACTION_TYPES.UPDATE_SURVEY):
    case FAILURE(ACTION_TYPES.DELETE_SURVEY):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SURVEY_LIST):
      let res = action.payload.data;
      return {
        ...state,
        loading: false,
        entities: res.content,
        pageable: {
          sort: {
            sorted: res.pageable.sort.sorted,
            unsorted: res.pageable.sort.unsorted,
            empty: res.pageable.sort.empty,
          },
          pageSize: res.pageable.page_size,
          pageNumber: res.pageable.page_number,
          offset: res.pageable.offset,
          paged: res.pageable.paged,
          unpaged: res.pageable.unpaged,
        },
        totalElements: res.total_elements,
        last: res.last,
        totalPages: res.total_pages,
        sort: res.sort,
        first: res.first,
        numberOfElements: res.number_of_elements,
        size: res.size,
        number: res.number,
        empty: res.empty,
      };
    case SUCCESS(ACTION_TYPES.FETCH_SURVEY):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_SURVEY):
    case SUCCESS(ACTION_TYPES.UPDATE_SURVEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_SURVEY):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.RESET:
      return { ...initial };
      case ACTION_TYPES.PREVIEW_SELECT_CHOICE: {
        if (state.previewAnswer.filter(f => f.id === action.payload.id) < 1) {
          return {
            ...state,
            previewAnswer: [...state.previewAnswer, action.payload],
          };
        } else {
          return {
            ...state,
            previewAnswer: state.previewAnswer.map(p => {
              if (p.id === action.payload.id) {
                return {
                  ...p,
                };
              } else {
                return p;
              }
            }),
          };
        }
      }
      case ACTION_TYPES.PREVIEW_RESET_CHOICE: {
        return {
          ...state,
          previewAnswer: [],
        };
      }
      case ACTION_TYPES.REMOVE_CHOICE_SURVEY: {
        let id = action.payload.id;
        let question = state.entity.questions.elements.filter(f => f.id !== id);
        return {
          ...state,
          entity: {
            ...state.entity,
            questions: {
              elements: [...question],
            },
          },
        };
      }
      case ACTION_TYPES.ADD_CHOICE: {
        let questionElement = action.payload.questions.elements;
        
        let elements = [...state.entity.questions.elements, ...questionElement];

        return {
          ...state,
          entity: {
            ...state.entity,
            questions:{
              elements
            },
          },
        };
      }
      case ACTION_TYPES.UPDATE_CHOICE: {
        let questionElement = action.payload.questions.elements;
        // return state;
        let newQ = state.entity.questions.elements.map(q => {
          if (q.id === questionElement[0].id) {
            return {
              ...q,
              ...questionElement[0],
            };
          } else {
            return q;
          }
        });
        return {
          ...state,
          entity: {
            ...state.entity,
            questions:{
              elements:newQ
            }
          },
        };
      }
    default:
      return state;
  }
};

export default surveyReducer;

// ACTIONS
export const getEntities = (page, size, sort) => ({
  type: ACTION_TYPES.FETCH_SURVEY_LIST,
  payload: axios.get(apiUrl, {
    params: {
      page: undefined || page,
      size: undefined || size,
      sort: undefined || sort,
    },
  }),
});

export const getEntity = id => ({
  type: ACTION_TYPES.FETCH_SURVEY,
  payload: axios.get(`${apiUrl}/${id}`),
});

export const createEntity = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_SURVEY,
    payload: axios.post(apiUrl, entity),
    meta: { successMessage: `Berhasil simpan!` },
  });
  return result;
};

export const getEntitiesCondition = (condition, page, sort) => ({
  type: ACTION_TYPES.FETCH_SURVEY_LIST,
  payload: axios.get(`${apiUrl}/search?q=${condition}`, {
    params: {
      page: undefined || page,
      sort: undefined || sort
    },
  })
});

export const updateEntity = (entity, id, pagination, pencarian, condition, sortBy) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_SURVEY,
    payload: axios.patch(`${apiUrl}/${id}`, entity),
    meta: { successMessage: `Berhasil update!` },
  });
  if(pagination === undefined){
    dispatch(getEntities(null, null, 'name,asc'));
  }else{
    if(pencarian === true){
      let condition2 = "name:"+condition;
      dispatch(getEntitiesCondition(condition2, pagination.current-1, sortBy));
    }else{
      dispatch(getEntities(pagination.current - 1, null, sortBy));
    }
  }
  
  return result;
};

export const deleteEntity = (id, sortBy, pagination, pencarian, condition) => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_SURVEY,
    payload: axios.delete(`${apiUrl}/${id}`),
    meta: { errorMessage: `Gagal hapus!`, successMessage: `Berhasil Hapus!` },
  });
  if(pencarian === true){
    let condition2 = "name:"+condition;
    dispatch(getEntitiesCondition(condition2, pagination.current-1, sortBy));
  }else{
    dispatch(getEntities(pagination.current - 1, null, sortBy));
  }
  
  return result;
};

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});

export const updateChoice = payload => ({
  type: ACTION_TYPES.UPDATE_CHOICE,
  payload,
});

// add entry to `question_list` & `answer_list`
export const addChoice = payload => ({
  type: ACTION_TYPES.ADD_CHOICE,
  payload,
});

export const previewSelectChoice = payload => ({
  type: ACTION_TYPES.PREVIEW_SELECT_CHOICE,
  payload,
});

export const removeChoice = payload => ({
  type: ACTION_TYPES.REMOVE_CHOICE_SURVEY,
  payload,
});

export const previewResetChoice = () => ({
  type: ACTION_TYPES.PREVIEW_RESET_CHOICE,
});
